/**
 * @fileoverview Helper module for entity picker cart data models
 * @author Sahil Parikh sparikh@yext.com
 */
// @ts-nocheck
goog.declareModuleId('yext.ui.components.entitypicker.cart.modelhelpers');

import {ItemTypes} from '/ui/components/entitypicker/container/itemtypes';
import {CartModel} from '/ui/components/entitypicker/cart/cartmodel';
import {SelectionModel} from '/ui/components/entitypicker/cart/selectionmodel';

/**
 * @param {!SelectionModel} selection
 * @return {?}
 */
export function selectionModelToUrlObject(selection) {
  const getId = i => i.id;
  const model = {};
  const addIfNotEmpty = (key, items) => {
    if (items && items.length > 0) {
      model[key] = items;
    }
  };

  let allSelected = selection.allSelected;
  if (allSelected) {
    if (!Array.isArray(allSelected)) {
      allSelected = itemTypeToString(selection.allSelected);
    } else {
      allSelected = selection.allSelected.map(type => itemTypeToString(type));
    }
  }

  addIfNotEmpty('allSelected', allSelected);
  addIfNotEmpty('entityTypes', selection.entityTypes.map(getId));
  addIfNotEmpty('entities', selection.entities.map(getId));
  addIfNotEmpty('folders', selection.folders.map(getId));
  addIfNotEmpty('labels', selection.labels.map(getId));
  return Object.freeze(model);
}

/**
 * @param {!CartModel} cartModel to convert
 * @param {!Object=} options options that help selection conform to external API that
 * developer will expect to see
 * @return {!SelectionModel}
 */
export function cartModelToSelectionModel(cartModel, options) {
  let selectionAllSelected = cartModel.allSelected;
  if (options && !options.multiCategory) {
    if (cartModel.allSelected.length > 0) {
      selectionAllSelected = cartModel.allSelected[0];
    }
  }
  const selection = {
    total: cartModel.total,
    allSelected: selectionAllSelected,
    entityTypes: cartModel.entityTypes,
    entities: cartModel.entities,
    folders: cartModel.folders,
    labels: cartModel.labels,
  };
  return selection;
}

/**
 * @param {?} selection to convert
 * @return {?}
 */
export function fromSelectionModelToCartModel(selection) {
  const selectionCopy = Object.assign({}, selection);
  if (!Array.isArray(selectionCopy.allSelected)) {
    selectionCopy.allSelected = [selectionCopy.allSelected];
  }
  return new CartModel(true, selectionCopy);
}

// TODO(sparikh): make function to convert UrlObject to CartModel?

/**
 * @param {*} type something that could be an itemType symbol
 * @return {?string} the string version of the itemType or null if param is not an itemType
 */
function itemTypeToString(type) {
  switch (type) {
    case ItemTypes.ENTITIES:
      return 'ENTITIES';
    case ItemTypes.FOLDERS:
      return 'FOLDERS';
    case ItemTypes.LABELS:
      return 'LABELS';
    case ItemTypes.ENTITYTYPES:
      return 'ENTITYTYPES';
    default:
      return null;
  }
}
